import React from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';

const AboutMe = () => {
    const navigate = useNavigate();

    return (
        <div className="App">
             <header className="hero-section" style={{ minHeight: 'auto', padding: '60px 20px', paddingBottom: '20px' }}>
                <div className="hero-content">
                    <h1 className="app-title" style={{ fontSize: '3.5rem', marginBottom: '10px' }}>קצת עליי</h1>
                </div>
            </header>
            
            <section className="about-content" style={{
                maxWidth: '800px',
                margin: '0 auto',
                padding: '0 20px 80px',
                textAlign: 'center',
                direction: 'rtl'
            }}>
                <div style={{
                    marginBottom: '40px',
                    borderRadius: '50%',
                    overflow: 'hidden',
                    width: '200px',
                    height: '200px',
                    margin: '0 auto 40px',
                    border: '4px solid rgba(255, 255, 255, 0.2)',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.5)'
                }}>
                    <img src="/me.jpg" alt="Liad Zigdon" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>

                <div className="about-text" style={{ fontSize: '1.2rem', lineHeight: '1.8', color: 'rgba(255, 255, 255, 0.9)' }}>
                    <p style={{ marginBottom: '20px' }}>
                        אהלן! אני ליעד. קצין, מפתח, ובעיקר אחד שהיה בדיוק
                        במקום שלכם. 👋
                    </p>
                    <p style={{ marginBottom: '20px' }}>
                        כשרציתי לצאת לקצונה, חיפשתי בנרות משהו ללמוד איתו
                        למקראות ישראל שלא ירדים אותי תוך דקה וחצי. גיליתי
                        שאין שום דבר נגיש או נוח, ושהברירה היחידה היא
                        סיכומים משנת תרפפ״ו! 🔍
                    </p>
                    <p style={{ marginBottom: '20px' }}>
                        אז במקום להתבכיין, החלטתי לנצל את הידע שלי בפיתוח
                        כדי לסגור לכם (ולי) את הפינה הזאת. המטרה? שתעברו את
                        המבחן הזה במינימום סבל ומקסימום ציון, ותגיעו לבה״ד 1
                        חדים. 💪
                    </p>
                    <p style={{ marginBottom: '40px' }}>
                        יאללה, תנו בראש, הסיכה מחכה לכם! בהצלחה! 🚀
                    </p>
                </div>

                <a 
                    href="mailto:lilizigi@gmail.com" 
                    className="download-button"
                    style={{ 
                        margin: '0 auto', 
                        display: 'inline-flex',
                        background: 'rgba(255,255,255,0.1)',
                        justifyContent: 'center',
                        textDecoration: 'none',
                        color: 'white'
                    }}
                >
                    <span style={{ marginLeft: '10px', fontSize: '1.5rem' }}>📧</span>
                    <span>שלחו לי מייל</span>
                </a>
                
                <div style={{ marginTop: '60px' }}>
                    <button 
                        onClick={() => navigate('/')} 
                        className="footer-link"
                        style={{
                            background: 'none',
                            border: 'none',
                            fontSize: '1rem',
                            cursor: 'pointer',
                            padding: '10px'
                        }}
                    >
                        חזרה לדף הבית
                    </button>
                </div>
            </section>
        </div>
    );
};

export default AboutMe;
